<template>
    <form-dialog
            v-model="isActive"
            :sending="sending"
            :title="edit ? $t('agricoltori.azioni.modifica') : $t('agricoltori.azioni.nuovo')"
            @confirm="onConfirm">

        <v-flex xs12>
            <icon-label icon="business" color="accent">{{ $t('agricoltori.label.dati_azienda') }}</icon-label>
        </v-flex>

        <v-flex v-if="edit" xs12>
            <text-field :label="$t('label.ragione_sociale')" v-model="form.ragione_sociale" required disabled/>
        </v-flex>

        <v-flex v-if="edit" xs12 md4>
            <text-field :label="$t('label.partita_iva')" v-model="form.partita_iva" show-details
                        :v-rules="[$utils.rules.partitaIVA]" disabled/>
        </v-flex>

        <v-flex xs12 sm6 md4>
            <v-autocomplete
                v-model="form.cuaa"
                :items="clienti"
                item-text="cuaa"
                item-value="id"
                :search-input.sync="search"
                :filter="customFilter"
                :label="$t('label.cuaa_ragione_sociale')"
                hide-no-data
                hide-selected
                clearable
                :return-object="false"
                required
            >
                <!-- LISTA PERSONALIZZATA -->
                <template v-slot:item="{ item }">
                    <div class="pa-2">
                        <div class="subtitle-1 font-weight-bold">
                            {{ item.ragione_sociale }}
                        </div>

                        <div class="caption grey--text">
                            {{ item.cuaa }}
                        </div>
                    </div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex v-if="!edit" xs12 sm6 md8>
            <v-btn color="accent" @click="searchClient">
                <v-icon class="mr-2">search</v-icon>
                {{ $t('azioni.cerca') }}
            </v-btn> 
        </v-flex>

        <v-flex v-if="!edit" xs12>
            <text-field :label="$t('label.ragione_sociale')" v-model="form.ragione_sociale" readonly disabled/>
        </v-flex>
        
        <v-flex v-if="edit" xs12 sm6 md4>
            <convenzioni-select :label="$t('label.convenzione')" v-model="form.id_convenzione" clearable attach/>
        </v-flex>

        <v-flex v-if="edit" xs12 class="mt-4">
            <icon-label icon="location_on" color="accent">{{ $t('label.indirizzo') }}</icon-label>
        </v-flex>

        <v-flex v-if="edit" xs12>
            <indirizzo-select
                    :paese.sync="form.nazione"
                    :regione.sync="form.regione"
                    :provincia.sync="form.provincia"
                    :comune.sync="form.comune"
                    :cap.sync="form.cap"
                    :frazione.sync="form.frazione"
                    :via.sync="form.via"
                    :numero-civico.sync="form.numero_civico"
                    show-frazione
                    :globalDisabled="true"
                    required
                    attach disabled/>
        </v-flex>

        <!--
        <v-flex v-if="edit" xs12 class="mt-4">
            <icon-label icon="person" color="accent">{{ $t('agricoltori.label.dati_titolare') }}</icon-label>
        </v-flex>
        -->

        <v-flex v-if="edit" xs12 class="mt-4">
            <icon-label icon="contacts" color="accent">{{ $t('label.contatti') }}</icon-label>
        </v-flex>

        <v-flex v-if="edit" xs12 sm4>
            <text-field :label="$t('label.pec')" v-model="form.pec" show-details :v-rules="[$utils.rules.email]" disabled/>
        </v-flex>

        <v-flex v-if="edit" xs12 md4>
            <text-field
                    :label="$t('label.email')"
                    v-model="form.email"
                    show-details
                    :v-rules="[$utils.rules.email]" disabled/>
        </v-flex>

        <v-flex v-if="edit" xs12 sm6 md4>
            <phone-field :label="$t('label.telefono')" v-model="form.telefono" show-details disabled/>
        </v-flex>

        <v-flex v-if="edit" xs12 sm6 md4>
            <mobile-phone-field :label="$t('label.cellulare')" v-model="form.cellulare" show-details disabled/>
        </v-flex>

        <template v-if="edit && form.note && form.note.length > 0">
            <v-flex xs12 class="mt-1">
                <icon-label icon="sort" color="accent">{{ $t('agricoltori.label.dati_aggiuntivi') }}</icon-label>
            </v-flex>

            <v-flex xs12 class="mt-1">
                <div v-for="(item, index) in form.note" :key="item[0]">
                    <span>{{ $t('label.' + item[0]) }}: </span>
                    <b>{{ item[1] }}</b>
                    <v-tooltip bottom>
                        <v-btn slot="activator" small icon class="my-0" @click="form.note.splice(index, 1)">
                            <v-icon>clear</v-icon>
                        </v-btn>
                        <span>{{ $t('azioni.rimuovi') }}</span>
                    </v-tooltip>
                </div>
            </v-flex>
        </template>

    </form-dialog>
</template>

<script>
import Sendable from '@/mixins/sendable'
import FormDialog from './base/FormDialog'
import { ConvenzioniSelect, DatePicker, IndirizzoSelect, MobilePhoneField, PhoneField } from './inputs'

export default {
    name: 'AgricoltoreDialog',
    mixins: [Sendable],
    components: { FormDialog, DatePicker, IndirizzoSelect, ConvenzioniSelect, PhoneField, MobilePhoneField },
    props: {
        clienti: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            defaultData: this.$schemas().agricoltore,
            oldConvenzione: null,
            search: ""
        }
    },
    methods: {
        action (refactorConvenzione) {
            if (this.edit) {
                return this.$api.agricoltori.update(this.form.id, this.form, refactorConvenzione)
            } else {
                // delete this.form.id;
                return this.$api.agricoltori.create(this.form)
            }
        },
        afterInitialize () {
            this.oldConvenzione = this.form.id_convenzione
        },
        onConfirm () {
            // if (!this.form.partita_iva) {
            //     // Se la partita IVA è vuota mostro un dialog di conferma invio dati
            //     this.$confirmDialog.show(0, this.$t('agricoltori.messaggi.conferma_salvataggio_partita_iva_mancante'), this.send, { color: 'warning' })
            // } else {
                this.send()
            // }
        },
        send () {
            this.sending = true
            this.action(this.edit && this.oldConvenzione !== this.form.id_convenzione).then(() => {
                this.onSuccess(this.edit ? this.$t('agricoltori.messaggi.modificato') : this.$t('agricoltori.messaggi.creato'))
            }).catch(e => {
                if (e.response && e.response.data && e.response.status === 400) {
                    if (e.response.data.message === 'regenerate') {
                        this.sending = false
                        let vue = this
                        //  E' già stata creata un agricoltore con questa partita IVA, mostro la conferma di ripristino
                        this.$confirmDialog.show(
                            e.response.data.id,
                            this.$t('agricoltori.messaggi.conferma_ripristino_duplicato'),
                            function (id) {
                                this.$api.agricoltori.restore(id).then(() => {
                                    vue.onSuccess(this.$t('agricoltori.messaggi.ripristinato'))
                                })
                            }, { confirmText: this.$t('azioni.ripristina'), color: 'error' })
                    } else if (e.response.data.message === 'PI duplicate') {
                        this.onError(this.$t('agricoltori.errori.partita_iva_duplicata'))
                    } else {
                        this.onError(this.$t('errori.server'))
                    }
                } else {
                    this.onError(this.$t('errori.server'))
                }
            })
        },
        searchClient ()
        {
            this.$api.clienti.getFromCuaa(this.form.cuaa)
                .then(response => {
                    console.log(response.data[0])
                    this.form = response.data[0];
                }).catch(e => {
                    this.$snackbar.showServerError(e)

                    console.log(e);
                })
        },
        customFilter(item, queryText) {
            if (!item) return false

            const text = `${item.ragione_sociale} ${item.cuaa}`.toLowerCase()

            // Splitta la query in parole → "miller franz" → ["miller", "franz"]
            const words = queryText.toLowerCase().split(/\s+/).filter(w => w.length > 0)

            // Ogni parola deve essere trovata nel testo
            return words.every(word => text.includes(word))
        }
    }
}
</script>
